import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { BASE_URL } from "../../utils/BaseUrl"
import httpRequest from "../../utils/httpsRequest";


export const fetchFoodCategories = createAsyncThunk(
  "category/fetchFoodCategories",
  async (arg) => {
      return httpRequest(`${BASE_URL}/FoodCategories?SearchText=${arg.searchText}&PageSize=${arg.pageSize}&PageNumber=${arg.pageNumber}`);
  }
)

const categoriesSlice = createSlice({
  name: "category",
  initialState: {
    category: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchFoodCategories.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchFoodCategories.fulfilled, (state, action) => {
        state.loading = false;
        state.category = action.payload;
      })
      .addCase(fetchFoodCategories.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  } 

});


export default categoriesSlice.reducer;
